import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cms-web-dev',
  templateUrl: './cms-web-dev.component.html',
  styleUrls: ['./cms-web-dev.component.css']
})
export class CmsWebDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/cms-web-dev/cms-web-dev.component.ts